import { Box, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { RELIGIOUS_AFFILIATION_OPTIONS, ReligiousAffiliation } from '../types'

interface FilterReligiousAffiliationProps {
  religiousAffiliation: ReligiousAffiliation[]
  setReligiousAffiliation: (affiliations: ReligiousAffiliation[]) => void
}

const FilterReligiousAffiliation = ({
  religiousAffiliation,
  setReligiousAffiliation,
}: FilterReligiousAffiliationProps) => {
  // sorts empty option last so Unknown isn't at the top
  const sortedReligiousAffiliation = [...RELIGIOUS_AFFILIATION_OPTIONS].sort((a, b) => {
    if (a === '') return 1
    if (b === '') return -1
    return a.localeCompare(b)
  })
  return (
    <Box>
      <Typography
        variant="body1"
        gutterBottom
      >
        Religious Affiliation
      </Typography>
      <Autocomplete
        value={religiousAffiliation}
        multiple
        filterSelectedOptions
        options={sortedReligiousAffiliation}
        disableCloseOnSelect
        ChipProps={{ color: 'primary', variant: 'outlined' }}
        getOptionLabel={(option) => (option === '' ? 'Unknown' : option)}
        onChange={(_, newValue) => setReligiousAffiliation(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            color="primary"
            variant="outlined"
            placeholder="Add Affiliation"
            aria-label="Religious Affiliation Filter"
          />
        )}
      />
    </Box>
  )
}

export default FilterReligiousAffiliation
